import React, { useContext } from "react";

import { Grid } from "@material-ui/core";
import {
  InputOptionMaster,
  InputReactDatepicker,
  InputTextArea,
  InputTextMaster,
  MasterButton,
} from "App/Component/ui";
import { FormContext } from "../../context/FormContext";
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
} from "App/constants";
import {
  convertToValidPrice,
  defaultToastError,
  defaultToastSuccess,
  formatRupiah,
  isNull,
} from "App/utils/helpers";
import {
  createHeader,
  FORM_RESET_DETAIL_PAKET,
  FORM_RESET_STATE_PAKET_TELE,
  updateHeader,
} from "../../helpers";
export default function FormInput(setNewDataPaketList) {
  const {
    formData,
    setFormData,
    setDisabled,
    disabled,
    setListPaket,
    setFormDetail,
  } = useContext(FormContext);

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    if (
      isNull(formData.code) ||
      isNull(formData.nama) ||
      isNull(formData.status) ||
      isNull(formData.tanggal_start) ||
      isNull(formData.tanggal_expired)
    ) {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError("Harap lengkapi form !");
    } else {
      try {
        if (isNull(formData.id)) {
          const res = await createHeader(formData);
          if (res.data.status === 201) {
            defaultToastSuccess("Berhasil menambah data");
            setFormData({
              ...formData,
              id: res.data.data.id,
            });
          } else {
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
            defaultToastError(res.data.message);
          }
        } else {
          const res = await updateHeader(formData);
          if (res.data.status === 200) {
            defaultToastSuccess("Berhasil memperbarui data");
          } else {
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
            defaultToastError(res.data.message);
          }
        }
      } catch (error) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        defaultToastError(error?.response?.data?.message);
      }
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
    }
  };

  const handleReset = () => {
    setFormData(FORM_RESET_STATE_PAKET_TELE);
    setFormDetail(FORM_RESET_DETAIL_PAKET);
    setListPaket([]);
  };

  return (
    <form action="POST" onSubmit={(e) => handleSubmit(e)}>
      <Grid container spacing={1}>
        <Grid item sm={12} md={9}>
          <Grid container spacing={1}>
            <Grid item sm={12} md={3}>
              <InputTextMaster
                name="id"
                label="ID PAKET TELEKONSUL"
                id="id"
                disabled={true}
                value={isNull(formData.id) ? "-" : formData?.id}
              />
            </Grid>
            <Grid item sm={12} md={3}>
              <InputTextMaster
                name="nama"
                label="NAMA PAKET"
                id="nama"
                placeholder="Nama Paket"
                value={formData.nama}
                onChange={handleChange("nama")}
              />
            </Grid>
            <Grid item sm={12} md={3}>
              <InputTextMaster
                name="code_paket"
                label="KODE"
                id="nama"
                placeholder="Kode"
                value={formData.code}
                onChange={handleChange("code")}
              />
            </Grid>
            <Grid item sm={12} md={3}>
              <InputOptionMaster
                name="status_paket"
                label="STATUS"
                id="status_paket"
                withSearch={true}
                data={[
                  {
                    value: 1,
                    label: "Aktif",
                  },
                  {
                    value: 0,
                    label: "Non-Aktif",
                  },
                ]}
                value={formData?.status}
                labelValue={formData?.status_nama}
                onChange={(e) => {
                  if (isNull(e)) {
                    setFormData({
                      ...formData,
                      status: "",
                      status_nama: "Pilih Status",
                    });
                  } else {
                    setFormData({
                      ...formData,
                      status: e.value,
                      status_nama: e.label,
                    });
                  }
                }}
              />
            </Grid>

            <Grid item sm={12} md={4}>
              <InputReactDatepicker
                selected={formData.tanggal_start}
                label="TANGGAL"
                handleChangeToday={(e) =>
                  setFormData({
                    ...formData,
                    tanggal_start: e,
                  })
                }
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    tanggal_start: e,
                    tanggal_expired: new Date(e),
                  })
                }
                withPeriode={true}
              >
                <button
                  type={"button"}
                  onClick={null}
                  style={{
                    borderLeft: "1px solid #EAEAEA",
                    borderTop: "1px solid #EAEAEA",
                    borderBottom: "1px solid #EAEAEA",
                    borderRight: "1px solid #EAEAEA",
                    background: "#fff",
                    padding: "0 0.8rem 0 0.8rem",
                    cursor: "pointer",
                    // borderRadius: "6px 0 0 6px",
                    fontSize: "10px",
                  }}
                >
                  s/d
                </button>
                <InputReactDatepicker
                  selected={formData.tanggal_expired}
                  label=""
                  minDate={new Date(formData.tanggal_start)}
                  handleChangeToday={(e) =>
                    setFormData({
                      ...formData,
                      tanggal_expired: e,
                    })
                  }
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      tanggal_expired: e,
                    })
                  }
                  withParentPeriode={true}
                />
              </InputReactDatepicker>
            </Grid>

            <Grid item sm={12} md={4}>
              <InputTextMaster
                name="diskon"
                label="DISKON"
                id="diskon"
                placeholder="0"
                value={formData.diskon}
                onInput={(e) => {
                  let val = e.target.value;
                  setFormData({
                    ...formData,
                    diskon: formatRupiah(val),
                  });
                }}
                withButton={true}
              >
                <button
                  type={"button"}
                  onClick={null}
                  style={{
                    borderRight: "1px solid #EAEAEA",
                    borderTop: "1px solid #EAEAEA",
                    borderBottom: "1px solid #EAEAEA",
                    borderLeft: "0",
                    background: "#fff",
                    padding: "0 0.8rem",
                    cursor: "pointer",
                    borderRadius: "0 6px 6px 0",
                  }}
                >
                  %
                </button>
              </InputTextMaster>
            </Grid>

            <Grid item sm={12} md={4}>
              <InputTextMaster
                name="total_diskon"
                label="TOTAL DISKON"
                id="total_diskon"
                placeholder="0"
                value={formData.total_diskon2}
                onInput={(e) => {
                  let val = e.target.value;
                  setFormData({
                    ...formData,
                    total_diskon: convertToValidPrice(val),
                    total_diskon2: formatRupiah(val),
                  });
                }}
                withButtonLeft={true}
              >
                <button
                  type={"button"}
                  onClick={null}
                  style={{
                    borderLeft: "1px solid #EAEAEA",
                    borderTop: "1px solid #EAEAEA",
                    borderBottom: "1px solid #EAEAEA",
                    borderRight: "0",
                    background: "#fff",
                    padding: "0 0 0 0.8rem",
                    cursor: "pointer",
                    borderRadius: "6px 0 0 6px",
                    fontSize: "10px",
                  }}
                >
                  Rp.
                </button>
              </InputTextMaster>
            </Grid>

            <Grid item sm={12} md={4}>
              <InputTextMaster
                name="biaya_lain"
                label="BIAYA LAIN"
                id="biaya_lain"
                placeholder="0"
                value={formData.biaya_lain2}
                onInput={(e) => {
                  let val = e.target.value;
                  setFormData({
                    ...formData,
                    biaya_lain: convertToValidPrice(val),
                    biaya_lain2: formatRupiah(val),
                  });
                }}
                withButtonLeft={true}
              >
                <button
                  type={"button"}
                  onClick={null}
                  style={{
                    borderLeft: "1px solid #EAEAEA",
                    borderTop: "1px solid #EAEAEA",
                    borderBottom: "1px solid #EAEAEA",
                    borderRight: "0",
                    background: "#fff",
                    padding: "0 0 0 0.8rem",
                    cursor: "pointer",
                    borderRadius: "6px 0 0 6px",
                    fontSize: "10px",
                  }}
                >
                  Rp.
                </button>
              </InputTextMaster>
            </Grid>

            <Grid item sm={12} md={4}>
              <InputTextMaster
                name="tax"
                label="TAX"
                id="tax"
                placeholder="0"
                value={formData.tax}
                onInput={(e) => {
                  let val = e.target.value;
                  setFormData({
                    ...formData,
                    tax: formatRupiah(val),
                  });
                }}
                withButton={true}
              >
                <button
                  type={"button"}
                  onClick={null}
                  style={{
                    borderRight: "1px solid #EAEAEA",
                    borderTop: "1px solid #EAEAEA",
                    borderBottom: "1px solid #EAEAEA",
                    borderLeft: "0",
                    background: "#fff",
                    padding: "0 0.8rem",
                    cursor: "pointer",
                    borderRadius: "0 6px 6px 0",
                  }}
                >
                  %
                </button>
              </InputTextMaster>
            </Grid>

            <Grid item sm={12} md={4}>
              <InputTextMaster
                name="total_tax"
                label="TOTAL TAX"
                id="total_tax"
                placeholder="0"
                value={formData.total_tax2}
                onInput={(e) => {
                  let val = e.target.value;
                  setFormData({
                    ...formData,
                    total_tax: convertToValidPrice(val),
                    total_tax2: formatRupiah(val),
                  });
                }}
                withButtonLeft={true}
              >
                <button
                  type={"button"}
                  onClick={null}
                  style={{
                    borderLeft: "1px solid #EAEAEA",
                    borderTop: "1px solid #EAEAEA",
                    borderBottom: "1px solid #EAEAEA",
                    borderRight: "0",
                    background: "#fff",
                    padding: "0 0 0 0.8rem",
                    cursor: "pointer",
                    borderRadius: "6px 0 0 6px",
                    fontSize: "10px",
                  }}
                >
                  Rp.
                </button>
              </InputTextMaster>
            </Grid>
          </Grid>
        </Grid>

        <Grid item sm={12} md={3}>
          <InputTextArea
            name="remark"
            label="CATATAN"
            id="remark"
            placeholder="Catatan"
            rows={9}
            value={formData.remark}
            onChange={handleChange("remark")}
          />
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <MasterButton
          className={"mt-1"}
          type="button"
          color={"danger"}
          outline={true}
          name={"RESET"}
          onClick={() => handleReset()}
          size="md"
        />

        <div>
          <MasterButton
            type={"submit"}
            color={disabled.color}
            name={disabled.label}
            disabled={disabled.disabled}
            size="lg"
          />
        </div>
      </Grid>
    </form>
  );
}
